// extracted by mini-css-extract-plugin
module.exports = {"root":"ConversationsListPage_root__2b8Is"};